import Flickity from 'flickity';
import { getBreakpoint, onLoadComplete, getIndexedHashProperty } from './_utils';
import { scrollToElement } from './scrollToQueryHash';

let indexedHashProperty = {};

const cssClass = 'TabContainer';
const classes = {
	activeTab: `${cssClass}-tab--active`,
	activePage: `${cssClass}-page--active`,
};
const selectors = {
	tabContainer: `.${cssClass}`,
	page: `.${cssClass}-page`,
	tab: `.${cssClass}-tab`,
};

const getAllIds = $tabContainer => {
	const $allTabs = $tabContainer.find(selectors.tab);
	const allIds = $allTabs.map((i, tab) => tab.dataset.id).toArray();

	return allIds;
};

const setActive = (id, $tabContainer) => {
	// Remove active class from all non-selected tabs / pages
	const $inactivePages = $tabContainer.find(`${selectors.page}:not([data-id=${id}])`);
	const $inactiveTabs = $tabContainer.find(`${selectors.tab}:not([data-id=${id}])`);
	$inactivePages.removeClass(classes.activePage);
	$inactivePages.attr('aria-hidden', true);
	$inactiveTabs.removeClass(classes.activeTab);
	$inactiveTabs.attr('aria-selected', false);

	// Add active class to all non-selected tabs / pages
	const $activePage = $tabContainer.find(`${selectors.page}[data-id=${id}]`);
	const $activeTab = $tabContainer.find(`${selectors.tab}[data-id=${id}]`);
	$activePage.addClass(classes.activePage);
	$activePage.attr('aria-hidden', false);
	$activeTab.addClass(classes.activeTab);
	$activeTab.attr('aria-selected', true);

	// Update components that need to be updated/re-initialized
	updateFlickityComponents($tabContainer);
};

const updateFlickityComponents = $tabContainer => {
	const tabContainerFlickityCarousels = $tabContainer[0].querySelectorAll('.flickity-enabled');
	[...tabContainerFlickityCarousels].forEach(flickityCarousel => {
		const flickity = new Flickity(flickityCarousel);
		flickity.resize();
	});
};

const handleTabClick = e => {
	const $clickedTab = $(e.currentTarget);

	if ($clickedTab.length > 0) {
		const bp = getBreakpoint();
		if (bp === 'small' || bp === 'medium') {
			$clickedTab[0].scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center',
			});
		}

		const $tabContainer = $clickedTab.closest(selectors.tabContainer);
		const activeId = $clickedTab.data('id');
		setActive(activeId, $tabContainer);
	}
};

const addEventListeners = $tabContainer => {
	const $allTabs = $tabContainer.find(selectors.tab);

	// Add event listeners
	$allTabs.on('click', handleTabClick);
};

const initializeTabContainer = (i, element) => {
	// Find DOM elements
	const $tabContainer = $(element);
	const allIds = getAllIds($tabContainer);

	onLoadComplete(() => {
		addEventListeners($tabContainer);

		const tabId = $tabContainer.attr('id');
		if (indexedHashProperty && tabId === indexedHashProperty.id) {
			scrollToElement($tabContainer);

			// Set requested page to active
			let activeIndex = indexedHashProperty.index - 1;
			if (activeIndex >= allIds.length) {
				activeIndex = 0;
			}
			setActive(allIds[activeIndex], $tabContainer);
		}
	});

	// Set first page to active
	setActive(allIds[0], $tabContainer);
};

export default function initializeTabContainers() {
	indexedHashProperty = getIndexedHashProperty();
	const $allTabContainers = $(selectors.tabContainer);
	$allTabContainers.each(initializeTabContainer);
}
